import { object, string } from 'yup';
import { useLocalization } from 'localization';
import { ORDER_CREATION_PACKAGE_TYPE } from 'constants/ui/status';

export const orderMaterialSchema = () => {
  const { t } = useLocalization();
  const EXCLUDED_TYPES = [ORDER_CREATION_PACKAGE_TYPE.property, ORDER_CREATION_PACKAGE_TYPE.ads] as readonly string[];

  const requiredMsg = t('validation.mixed.required');
  const emailMsg = t('validation.string.email');
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return object().shape({
    type: string().default(ORDER_CREATION_PACKAGE_TYPE.property),
    selectedDepartmentId: object()
      .shape({
        label: string().required(requiredMsg),
        value: string().required(requiredMsg),
      })
      .required(requiredMsg),
    selectedAddress: object({
      label: string().required(requiredMsg),
      value: string().required(requiredMsg),
    })
      .required(requiredMsg)
      .when('type', {
        is: (value: string) => !EXCLUDED_TYPES.includes(value),
        then: schema =>
          schema
            .test('isEmail', emailMsg, opt => !!opt && !!opt.value && emailRegex.test(opt.value.trim()))
            .typeError(emailMsg),
        otherwise: schema =>
          schema.test('isValidValue', requiredMsg, opt => !!opt && !!opt.value).typeError(requiredMsg),
      }),
  });
};
